import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
/*
Ver documentación en: https://vuex.vuejs.org/api/#mutations
*/

const ProfileUserVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "AccountUsers/v1.0/",
    users: {},
    $_currentProfile: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    Users: (state) => state.users,
    currentProfile: (state) => state.$_currentProfile,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initProfile({ commit }) {
      var profile = {
        id: 0,
        name: "",
        active: false,
        roles: [],
        application: {
          id: 0
        }
      };

      commit("SET_PROFILE", profile);
    },
    clearUsers({ commit }) {
      commit("SET_USERS", {});
    },
    setProfile({ commit }, profile) {
      commit("SET_PROFILE", profile);
    },
    async GetUser({ commit, dispatch, state, rootGetters }, data) {
      var authUrl = rootGetters.authUrl;
      var actionLink = `${authUrl}${state.$_moduleApiPath}GetApplicationUserAccountIdAsync`;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        var payload = { Id: data.data.Id };
        const response = await axios.post(actionLink, payload, axiosConfig);
        commit("SET_USERS", response.data.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async UpdateProfile({ commit, dispatch, state, rootGetters }, data) {
      var authUrl = rootGetters.authUrl;
      var actionLink = `${authUrl}${state.$_moduleApiPath}UpdateAccountAsync`;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(actionLink, data.data, axiosConfig);
        var salida = response.data;
        if (salida.success) {
          return true;
        } else {
          commit("SET_ERROR", salida.message);
          throw salida.message;
        }
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async ChangePasswordProfile(
      { commit, dispatch, state, rootGetters },
      data
    ) {
      var authUrl = rootGetters.authUrl;
      var actionLink = `${authUrl}${state.$_moduleApiPath}ChangePassworAsync`;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(actionLink, data.data, axiosConfig);
        var salida = response.data;
        if (salida.success) {
          return true;
        } else {
          commit("SET_ERROR", salida.message);
          throw salida.message;
        }
      } catch (error) {
        GetErrors(commit, error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_USERS(state, value) {
      state.users = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

function GetErrors(commit, error) {
  var dataError = JSON.parse(JSON.stringify(error.response.data));
  var dataMessage = JSON.parse(JSON.stringify(dataError.errors[0]));
  commit("SET_ERROR", dataMessage);
}

export default ProfileUserVuexModule;
